import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import ConfirmationModal from '/imports/ui/components/common/modal/confirmation/component';

const intlMessages = defineMessages({
  leaveSessionTitle: {
    id: 'app.leaveSession.title',
    description: 'leave session title',
  },
  leaveSessionDescription: {
    id: 'app.leaveSession.description',
    description: 'leave session description',
  },
  confirmButtonLabel: {
    id: 'app.leaveSession.yesLabel',
    description: 'leave session confirm button label',
  },
});

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  leaveSession: PropTypes.func.isRequired,
};

class LeaveSessionComponent extends PureComponent {
  render() {
    const {
      intl, leaveSession, isOpen, onRequestClose, priority, setIsOpen,
    } = this.props;

    // const title = intl.formatMessage(intlMessages.leaveSessionTitle);
    // const description = intl.formatMessage(intlMessages.leaveSessionDescription);
    const title = 'Leave Session';
    const description = 'Are you sure you want to leave this session?';

    return (
      <ConfirmationModal
        intl={intl}
        onConfirm={leaveSession}
        title={title}
        description={description}
        confirmButtonColor="primary"
        confirmButtonDataTest="confirmLeaveSession"
        confirmButtonLabel={'Yes'}
        cancelButtonLabel={'No'}
        {...{
          isOpen,
          onRequestClose,
          priority,
          setIsOpen,
        }}
      />
    );
  }
}

LeaveSessionComponent.propTypes = propTypes;

export default injectIntl(LeaveSessionComponent); 